import { Component } from '@angular/core';

@Component({
  selector: 'demo-spacing',
  templateUrl: './spacing.component.html',
  styleUrls: ['./spacing.component.scss'],
  standalone: false,
})
export class DemoSpacingComponent {}
